import {makeStyles} from 'tss-react/mui';
import {
   PtrnCampoEditable,
   PtrnCampoEditableAccionFn,
   PtrnCampoEditableAcciones,
   PtrnIcons
} from '../../patronTypes';

export const useInputStyles = makeStyles()((theme) => ({
   ceFocused: {
      '&.Mui-focused': {
         //TODO en caso sea necesario modificar y hacer mas aparente el focus
      }
   }
}));

export function getNoBorderSx(campoConfig: PtrnCampoEditable) {
   return campoConfig.noBorder ? {'& fieldset': {border: 'none'}} : undefined;
}

/**
 * Define el espacio q ocuparan los botones de acciones definidos por `acciones` y convierte las acciones nombradas en un arreglo de objetos, el icono y la funcion q representa la accion, para facilitar su procesamiento
 * @param acciones Acciones relacionadas con el campo
 * @returns
 */
export function generarAccionesDeCampo(acciones?: PtrnCampoEditableAcciones) {
   let accionesDeCampo: {
      accionesxs: number;
      acciones: {icon: PtrnIcons; fn: PtrnCampoEditableAccionFn}[];
   } = {
      accionesxs: 0,
      acciones: []
   };
   if (acciones && acciones.onClickSearch && accionesDeCampo.accionesxs < 6) {
      accionesDeCampo.accionesxs++;
      accionesDeCampo.acciones.push({icon: PtrnIcons.search, fn: acciones.onClickSearch});
   }
   return accionesDeCampo;
}
